(function () {
  const CartDrawer = {
    _pendingChanges: {},
    _cartItems: [],

    async open(highlightVariantId) {
      document.getElementById('cart-drawer-overlay').style.display = 'block';
      const drawer = document.getElementById('cart-drawer');
      drawer.style.display = 'flex';
      setTimeout(() => (drawer.style.transform = 'translateX(0)'), 10);
      document.body.style.overflow = 'hidden';

      // 每次打开重置状态
      this._pendingChanges = {};
      this._cartItems = [];

      this._showLoading();
      await this._loadCart();
    },

    // 修复3：先关闭动画，后台静默写入
    close() {
      const drawer = document.getElementById('cart-drawer');
      drawer.style.transform = 'translateX(100%)';
      setTimeout(() => {
        drawer.style.display = 'none';
        document.getElementById('cart-drawer-overlay').style.display = 'none';
        document.body.style.overflow = '';
      }, 300);

      // 后台静默写入，不阻塞 UI
      this._flushChanges().catch((e) => console.error('CartDrawer: flush error', e));
    },

    // 修复1：区分"只改数量"和"切换变体"两种情况
    async _flushChanges() {
      const changes = Object.values(this._pendingChanges).filter((c) => c.changed);
      if (changes.length === 0) return;

      for (const change of changes) {
        try {
          const originalItem = this._cartItems.find((i) => i.key === change.originalKey);
          const variantChanged = originalItem && originalItem.variant_id != change.variantId;

          if (variantChanged) {
            // 变体切换：删旧 + 加新
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: change.originalKey, quantity: 0 })
            });
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: change.variantId, quantity: change.qty })
            });
          } else {
            // 只改数量：直接更新
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: change.originalKey, quantity: change.qty })
            });
          }
        } catch (e) {
          console.error('CartDrawer: flush failed for', change.originalKey, e);
        }
      }

      // 更新购物车角标
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        this._updateCartCount(cart.item_count);
      } catch (e) {}
    },

    async _loadCart() {
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        this._cartItems = cart.items;

        // 并行获取所有商品产品数据（去重 handle）
        const handles = [...new Set(cart.items.map((item) => item.handle))];
        const productMap = {};
        await Promise.all(
          handles.map(async (handle) => {
            const res = await fetch(`/products/${handle}.js`);
            productMap[handle] = await res.json();
          })
        );

        // 初始化本地状态（直接赋值，open() 已清空）
        cart.items.forEach((item) => {
          this._pendingChanges[item.key] = {
            originalKey: item.key,
            variantId: item.variant_id,
            qty: item.quantity,
            changed: false,
            product: productMap[item.handle]
          };
        });

        this._updateCartCount(cart.item_count);

        // 修复7：先渲染（内部控制 footer），再显示内容区
        this._renderCart();
        this._showContent();
      } catch (e) {
        console.error('CartDrawer: load cart failed', e);
      }
    },

    // 渲染完全基于 _pendingChanges，各 item 互不干扰
    _renderCart() {
      const body = document.getElementById('cart-drawer-content');
      const footer = document.getElementById('cart-drawer-footer');
      const states = Object.values(this._pendingChanges);

      if (states.length === 0) {
        body.innerHTML = `
          <div style="text-align:center;padding:60px 0;color:#999;">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" style="margin-bottom:12px;opacity:0.3;display:block;margin-left:auto;margin-right:auto;">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="#999" stroke-width="1.5"/>
              <line x1="3" y1="6" x2="21" y2="6" stroke="#999" stroke-width="1.5"/>
              <path d="M16 10a4 4 0 01-8 0" stroke="#999" stroke-width="1.5"/>
            </svg>
            <div style="font-size:15px;">Your cart is empty.</div>
          </div>
        `;
        // 修复7：购物车为空时隐藏 footer
        if (footer) footer.style.display = 'none';
        return;
      }

      // 修复7：有商品时显示 footer
      if (footer) footer.style.display = 'block';

      let itemsHtml = '';
      let totalPrice = 0;

      states.forEach((state) => {
        const product = state.product;
        const originalItem = this._cartItems.find((i) => i.key === state.originalKey);
        if (!originalItem) return;

        const variant = product?.variants.find((v) => v.id == state.variantId);
        const price = variant ? variant.price : originalItem.price;
        const comparePrice = variant ? variant.compare_at_price : originalItem.compare_at_price;
        const image = variant?.featured_image?.src || originalItem.image;

        totalPrice += price * state.qty;

        const fakeItem = {
          ...originalItem,
          variant_id: state.variantId,
          price,
          compare_at_price: comparePrice,
          quantity: state.qty,
          image
        };

        const variantsHtml = this._buildVariantSelector(product, fakeItem);

        itemsHtml += `
          <div class="cart-drawer-item" data-line-key="${state.originalKey}"
            style="padding:16px 0;border-bottom:1px solid #f0f0f0;">
            <div style="display:flex;gap:14px;margin-bottom:12px;">
              <a href="/products/${originalItem.handle}" style="flex-shrink:0;">
                <img src="${image}" alt="${originalItem.product_title}"
                  style="width:80px;height:80px;object-fit:cover;border-radius:8px;border:1px solid #eee;">
              </a>
              <div style="flex:1;min-width:0;">
                <a href="/products/${originalItem.handle}"
                  style="font-size:14px;font-weight:600;color:#1a1a2e;text-decoration:none;line-height:1.4;display:block;margin-bottom:6px;">
                  ${originalItem.product_title}
                </a>
                <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;">
                  <span style="font-size:16px;font-weight:700;color:hsl(15 79% 51%);">
                    $${(price / 100).toFixed(2)}
                  </span>
                  ${comparePrice ? `<span style="font-size:12px;color:#999;text-decoration:line-through;">$${(comparePrice / 100).toFixed(2)}</span>` : ''}
                </div>
                <div style="display:flex;align-items:center;justify-content:space-between;">
                  <div style="display:flex;align-items:center;border:1px solid #ddd;border-radius:6px;overflow:hidden;">
                    <button class="cart-drawer-qty-btn" data-action="minus" data-line-key="${state.originalKey}"
                      style="width:32px;height:32px;background:#f5f5f5;border:none;cursor:pointer;font-size:18px;color:#333;line-height:1;">−</button>
                    <span class="cart-drawer-qty-display" data-line-key="${state.originalKey}"
                      style="width:36px;text-align:center;font-size:14px;font-weight:600;">${state.qty}</span>
                    <button class="cart-drawer-qty-btn" data-action="plus" data-line-key="${state.originalKey}"
                      style="width:32px;height:32px;background:#f5f5f5;border:none;cursor:pointer;font-size:18px;color:#333;line-height:1;">+</button>
                  </div>
                  <button class="cart-drawer-remove-btn" data-line-key="${state.originalKey}"
                    style="background:none;border:none;cursor:pointer;font-size:13px;color:#e53e3e;text-decoration:underline;padding:0;">
                    Remove
                  </button>
                </div>
              </div>
            </div>
            ${variantsHtml}
          </div>
        `;
      });

      body.innerHTML = itemsHtml;
      this._updateSubtotal(totalPrice / 100);
      this._bindCartEvents();
    },

    _buildVariantSelector(product, item) {
      if (!product) return '';
      if (product.options.length === 1 && product.options[0] === 'Title') return '';

      const currentVariant =
        product.variants.find((v) => v.id == item.variant_id) || product.variants[0];

      let html = `<div style="margin-top:4px;">`;
      html += `<div style="font-size:13px;font-weight:600;color:#1a1a2e;margin-bottom:10px;">Choose Your Variant</div>`;

      product.options.forEach((opt, optionIndex) => {
        const optionName = typeof opt === 'string' ? opt : opt.name;
        const values = [...new Set(product.variants.map((v) => v.options[optionIndex]))];

        html += `
          <div style="margin-bottom:10px;">
            <div style="font-size:12px;color:#888;margin-bottom:6px;">
              ${optionName}: <strong style="color:#333;">${currentVariant.options[optionIndex]}</strong>
            </div>
            <div style="display:flex;flex-wrap:wrap;gap:6px;">
        `;

        values.forEach((val) => {
          const isSelected = currentVariant.options[optionIndex] === val;
          const available = product.variants.some(
            (v) => v.options[optionIndex] === val && v.available
          );
          html += `
            <button
              class="cart-drawer-variant-btn"
              data-line-key="${item.key}"
              data-option-index="${optionIndex}"
              data-option-value="${val}"
              style="padding:5px 12px;border-radius:6px;
                border:${isSelected ? '2px solid hsl(15 79% 51%)' : '1px solid #ddd'};
                background:${isSelected ? '#fff5f0' : '#fff'};
                color:${isSelected ? 'hsl(15 79% 51%)' : available ? '#333' : '#bbb'};
                font-size:12px;font-weight:${isSelected ? '600' : '400'};
                cursor:${available ? 'pointer' : 'not-allowed'};
                opacity:${available ? '1' : '0.5'};"
              ${available ? '' : 'disabled'}
            >${val}</button>
          `;
        });

        html += `</div></div>`;
      });

      html += `</div>`;
      return html;
    },

    _bindCartEvents() {
      // 数量加减（只更新本地状态，不重渲染整个列表）
      document.querySelectorAll('.cart-drawer-qty-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const lineKey = btn.dataset.lineKey;
          const action = btn.dataset.action;
          const state = this._pendingChanges[lineKey];
          if (!state) return;

          if (action === 'minus' && state.qty > 1) {
            state.qty--;
            state.changed = true;
          } else if (action === 'plus') {
            state.qty++;
            state.changed = true;
          }

          const qtyEl = document.querySelector(
            `.cart-drawer-qty-display[data-line-key="${lineKey}"]`
          );
          if (qtyEl) qtyEl.textContent = state.qty;
          this._recalcSubtotal();
        });
      });

      // 修复5：删除后直接从本地状态移除，不重新调用 _loadCart
      document.querySelectorAll('.cart-drawer-remove-btn').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const lineKey = btn.dataset.lineKey;
          btn.disabled = true;
          btn.textContent = 'Removing...';

          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: lineKey, quantity: 0 })
            });

            // 修复5：明确清理本地状态，不残留
            delete this._pendingChanges[lineKey];
            this._cartItems = this._cartItems.filter((i) => i.key !== lineKey);

            // 更新角标
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();
            this._updateCartCount(cart.item_count);

            // 直接重渲染，不重新请求
            this._renderCart();
          } catch (e) {
            console.error('CartDrawer: remove failed', e);
            btn.disabled = false;
            btn.textContent = 'Remove';
          }
        });
      });

      // 变体切换（只更新本地状态，关闭时才写入购物车）
      document.querySelectorAll('.cart-drawer-variant-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const lineKey = btn.dataset.lineKey;
          const optionIndex = parseInt(btn.dataset.optionIndex);
          const optionValue = btn.dataset.optionValue;
          const state = this._pendingChanges[lineKey];
          if (!state) return;

          const product = state.product;
          const currentVariant = product.variants.find((v) => v.id == state.variantId);
          if (!currentVariant) return;

          const newOptions = [...currentVariant.options];
          newOptions[optionIndex] = optionValue;

          // 找完全匹配的变体
          let newVariant = product.variants.find((v) =>
            v.options.every((opt, i) => opt === newOptions[i])
          );

          // 修复4：找不到完全匹配时，fallback 到该选项下第一个可用变体
          if (!newVariant) {
            newVariant = product.variants.find(
              (v) => v.options[optionIndex] === optionValue && v.available
            );
          }

          if (!newVariant || newVariant.id == state.variantId) return;

          // 更新本地状态，数量重置为1，标记已变更
          state.variantId = newVariant.id;
          state.qty = 1;
          state.changed = true;

          // 重渲染（数据完全来自 _pendingChanges，各 item 互不干扰）
          this._renderCart();
        });
      });

      // 关闭按钮
      document.getElementById('cart-drawer-close-btn')?.addEventListener('click', () =>
        this.close()
      );
      document.getElementById('cart-drawer-continue-btn')?.addEventListener('click', () =>
        this.close()
      );
    },

    _recalcSubtotal() {
      const total = Object.values(this._pendingChanges).reduce((sum, state) => {
        const variant = state.product?.variants.find((v) => v.id == state.variantId);
        const originalItem = this._cartItems.find((i) => i.key === state.originalKey);
        const price = variant ? variant.price : originalItem?.price ?? 0;
        return sum + price * state.qty;
      }, 0);
      this._updateSubtotal(total / 100);
    },

    _updateSubtotal(totalFloat) {
      const el = document.getElementById('cart-drawer-subtotal');
      if (el) el.textContent = `$${totalFloat.toFixed(2)}`;
    },

    _updateCartCount(count) {
      document.querySelectorAll(
        '[data-cart-count], .cart-count, #cart-count, .cart__count'
      ).forEach((el) => (el.textContent = count));
    },

    _showLoading() {
      document.getElementById('cart-drawer-loading').style.display = 'flex';
      document.getElementById('cart-drawer-content').style.display = 'none';
      document.getElementById('cart-drawer-footer').style.display = 'none';
    },

    // 修复7：只控制 loading 隐藏和内容显示，footer 由 _renderCart 管理
    _showContent() {
      document.getElementById('cart-drawer-loading').style.display = 'none';
      document.getElementById('cart-drawer-content').style.display = 'block';
    },

    init() {
      const drawer = document.getElementById('cart-drawer');
      if (drawer) {
        drawer.style.transform = 'translateX(100%)';
        drawer.style.transition = 'transform 0.3s ease';
      }

      // 遮罩点击关闭
      document.getElementById('cart-drawer-overlay')?.addEventListener('click', () =>
        this.close()
      );

      // 方式B：监听全局加购事件
      document.addEventListener('cart:add-success', (e) => {
        this.open(e.detail?.variantId);
      });

      // ESC 关闭
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }
  };

  window.CartDrawer = CartDrawer;
  document.addEventListener('DOMContentLoaded', () => CartDrawer.init());
})();
